// extracted by mini-css-extract-plugin
export default {"paragraphContainer":"Paragraph_paragraphContainer__uVllB","titleContainer":"Paragraph_titleContainer__KRI3F"};